/** @jsx jsx */
import { jsx } from '@emotion/core'
import React from 'react'
import Iframe from 'react-iframe'
import { IframeWrap } from '@styles/base.style'

interface StatVisualizationProps {
  url: string
  className?: string
}

const StatVisualization: React.FC<StatVisualizationProps> = (props: StatVisualizationProps) => {
  const { url, className = '' } = props

  return (
    <IframeWrap
      className={`modal stat-visualization ${className}`}
    >
      <Iframe
        url={url}
        scrolling="no"
        width="100%"
        height="300px"
        frameBorder={0}
      />
    </IframeWrap>
  )
}

export default StatVisualization
